import Auth from 'components/Auth'
import './App.css'

const App = () => {
  return <Auth />
}

export default App
